import { NavLink } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../data/services';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';

function ServicesSection() {
  return (
    <section id="leistungen" className="py-12 sm:py-16 md:py-28">
      <div className="container-site mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="Leistungen"
            title="Alles, was Beton auf der Baustelle braucht."
            compact
          />
        </Reveal>

        <div className="grid md:grid-cols-3 gap-4 mt-8">
          {services.map((service, index) => (
            <Reveal key={service.slug} delay={index * 100}>
              <NavLink
                to={`/leistungen/${service.slug}`}
                className={`group relative flex flex-col min-h-[380px] sm:min-h-[420px] md:min-h-[440px] p-6 md:p-8 rounded-card border border-ink/10 bg-white/90 shadow-card transition-all duration-200 hover:-translate-y-1 hover:border-signal/40 hover:shadow-[0_18px_42px_rgba(13,37,46,0.12)] overflow-hidden ${
                  index === 1
                    ? 'bg-gradient-to-br from-[#10272f] to-[#0f4d62] text-white'
                    : ''
                }`}
              >
                <div className="absolute top-0 left-6 right-6 h-[3px] rounded-b-full bg-signal" aria-hidden="true" />
                <span
                  className={`text-sm font-extrabold mb-6 ${index === 1 ? 'text-signal' : 'text-teal'}`}
                >
                  {service.index}
                </span>
                <h3 className="text-lg sm:text-xl md:text-2xl font-extrabold leading-tight mb-3 pr-6">
                  {service.title}
                </h3>
                <p className={`text-sm sm:text-base leading-relaxed mb-6 ${index === 1 ? 'text-white/80' : 'text-ink-soft'}`}>
                  {service.description}
                </p>
                <ul className={`list-disc pl-4 mt-auto text-sm sm:text-base ${index === 1 ? 'text-white/80' : 'text-ink-soft'}`}>
                  {service.benefits.slice(0, 3).map((benefit) => (
                    <li key={benefit} className="mb-2">{benefit}</li>
                  ))}
                </ul>
                <div className={`mt-6 flex items-center gap-2 font-bold group-hover:underline ${index === 1 ? 'text-signal-light' : 'text-signal'}`}>
                  Mehr erfahren
                  <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </NavLink>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
